import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../services/cancel-order.service';
import { CancelOrderGarment } from '../../models/cancel-order.model';
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';

@Component({
    selector: 'app-all-cancel-order-page',
    templateUrl: 'all-cancel-order.page.html',
    styleUrls: [
      './all-cancel-order.page.scss',
    ]
  })
  export class AllCancelOrderPage implements OnInit  {

    constructor(
      private router: Router,
      private route: ActivatedRoute,
      public authService: GtrakAuthService,
      private cancelOrderService: CancelOrderService,
    ) { }
    currentDate = new Date();
    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean;
    requestParams:any;
    costCenterId:string;
    employeeCode:string;
    stopCode:string;
    Dept:string;
    customerId:string;
    header:string;
    departmentCode:string;
    customerName:string;
    departmentName:string;
     public viewChange: boolean = false;

    async ngOnInit() {
      this.loaded = false;
        this.requestParams = new RequestParams();
     this.customerId=this.route.snapshot.params.cid;
      this.requestParams.filters.CostCenterUser=localStorage.getItem('CostCenterUser');
         this.header='All Cancel Order ';
         await this.cancelOrderService.getAllCancelRecords( this.route.snapshot.params.cid, this.requestParams).then((cancelOrder) => {
             this.cancelOrders = cancelOrder;
            });
     
        this.loaded = true;
     if(this.cancelOrders!=undefined){
           if(this.cancelOrders.length>0){
            this.customerName=this.cancelOrders[0][0].customerName;
            this.departmentName=this.cancelOrders[0][0].departmentName;
        }
      for (let i = 0; i < this.cancelOrders.length; i++) {
        let woLossCharge = 0;
        const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
        for (let j = 0; j < cancelOrderGarments.length; j++) {
          if(cancelOrderGarments[j].dateCollected === null) {
            woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            //round to 2 decimal places
            woLossCharge = Math.round(woLossCharge * 100) / 100;
            this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
          }
        }
        this.cancelOrders[i].lossCharge = woLossCharge;
      }

      
    }
  }
   changePrinterView(): void {
    this.viewChange = !this.viewChange;
    // Set a delay before opening the print dialog
    setTimeout(() => {
      print();
    }, 1000); // 2000 milliseconds = 2 seconds
  }

doesFreqRunOnDate(strFrequency: string, forDate: Date, vbaseDate: Date): boolean {
  if (!strFrequency || strFrequency.trim() === '') {
    return false;
  }

  let tmp = Math.floor(
    Math.abs(
      (forDate.getTime() - vbaseDate.getTime()) / (1000 * 60 * 60 * 24)
    )
  );

  const idx = tmp % strFrequency.length;

  return strFrequency.charAt(idx) === '1';
}
  }